import type { QueryProps } from "shared/react";
import type { EarnedData, RewardData, RewardType } from "shared/schema";
import { Grid, Icon, Loader } from "shared/react";
import { formatCompactNumber } from "shared/util/number";
import { useQuery } from "../util/db.js";
import { BackgroundIcon, RawBackgroundIcon } from "./BackgroundIcon.js";
import { RawRewardIcon, RewardIcon } from "./RewardIcon.js";

export const REWARD_GRID_MODS = "gap-1x grid-cols-4 grid-square";
export const BACKGROUND_GRID_MODS = "gap-1x grid-cols-2 grid-background";

export function RewardGrid({ type, query, ...props }: { type: RewardType } & QueryProps<RewardData>): React.ReactElement {
	return (
		<Grid
			store={useQuery("reward", query)}
			mapper={({ id, name, image, hue }) => (
				<a key={id} href={`/reward/${id}`} className={type === "background" ? "background" : "icon"} title={name}>
					{type === "background" ? <RawBackgroundIcon image={image} hue={hue} /> : <RawRewardIcon image={image} type={type} />}
				</a>
			)}
			empty={`No ${type}s`}
			more={`More ${type}s`}
			mods={type === "background" ? BACKGROUND_GRID_MODS : REWARD_GRID_MODS}
			{...props}
		/>
	);
}

export function EarnedRewardGrid({ type, query, ...props }: { type: RewardType } & QueryProps<EarnedData>): React.ReactElement {
	return (
		<Grid //
			store={useQuery("earned", query)}
			mapper={({ rid, count }) => (
				<a key={rid} href={`/reward/${rid}`} className={type === "background" ? "background" : "icon"}>
					<Loader>{type === "background" ? <BackgroundIcon id={rid} /> : <RewardIcon id={rid} type={type} />}</Loader>
					<span className="badge badge-success pin-bottom pin-right">{type === "badge" ? formatCompactNumber(count) : <Icon icon="tick" />}</span>
				</a>
			)}
			empty={`No earned ${type}s`}
			more={`More ${type}s`}
			mods={type === "background" ? BACKGROUND_GRID_MODS : REWARD_GRID_MODS}
			{...props}
		/>
	);
}
